import { CommonPageLayoutModule } from './core/layouts/common-page-layout/common-page-layout.module';
import { SettingsRendererModule } from './pages/settings/general-settings/settings-renderer/settings-renderer.module';
import { ControlPopUpModule } from './widgets/control-pop-up/control-pop-up.module';
import { ServiceLocator } from './tools/service-locator.tool';
import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, LOCALE_ID, ErrorHandler, NgModule, Injector } from '@angular/core';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { APP_BASE_HREF, PlatformLocation, CommonModule } from '@angular/common';
import { DxPopupModule, DxButtonModule, DxTabsModule, DxScrollViewModule } from 'devextreme-angular';
import { localeIdFactory, localeInitializer, LocaleService } from './services/locale.service';
import { GlobalErrorHandler } from './common/global-error-handler';
import { InfoTableModule } from './widgets/info-table/info-table.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ConfirmationPopUpModule } from './widgets/confirmation-pop-up/confirmation-pop-up.module';
import { DefaultUrlSerializer, UrlSerializer as AngularUrlSerializer, UrlTree, RouteReuseStrategy as AngularRouteReuseStrategy } from '@angular/router';
import { SelectionOptionsRendererModule } from './pages/settings/selection-options/selection-options-renderer/selection-options-renderer.module';
import { RouteConfigService } from './routing/route-config.service';
import { RouteReuseStrategy } from './routing/strategies/route-reuse.strategy';
import { NavbarService } from './core/navigation/navbar/services/navbar.service';
import { IPublicClientApplication, PublicClientApplication, InteractionType, BrowserCacheLocation, LogLevel } from '@azure/msal-browser';
import { MsalGuard, MsalInterceptor, MsalBroadcastService, MsalInterceptorConfiguration, MsalModule, MsalService, MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalGuardConfiguration, MsalRedirectComponent } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';

import DataGrid, { Properties as dxDataGridProperties } from "devextreme/ui/data_grid";
import { NavbarModule } from './core/navigation/navbar/navbar.module';
import { TaskPopupModule } from './pages/task/task-popup/task-popup.module';
import { DEFAULTS, DEFAULTS_TOKEN } from './app.defaults';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import config from 'devextreme/core/config'

import { licenseKey } from 'src/app/helpers/devextreme-license';
import { DxDashboardControlModule } from 'devexpress-dashboard-angular';
import { QRCodeModule } from 'angularx-qrcode';
import { AuthInterceptor } from './interceptors/auth.interceptor';




config({
	licenseKey
});


export default class UrlSerializer implements AngularUrlSerializer {
	/**
	 * `DefaultUrlSerializer` is a default impelementation of url serializer provided by Angular.
	 */
	private _defaultUrlSerializer: DefaultUrlSerializer = new DefaultUrlSerializer();

	parse(url: string): UrlTree {
		// Encode "+" to "%2B"
		url = url.replace(/\+/gi, '%2B');
		// Use the default serializer.
		return this._defaultUrlSerializer.parse(url);
	}

	serialize(tree: UrlTree): string {
		return this._defaultUrlSerializer.serialize(tree).replace(/\+/gi, '%2B');
	}
}

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1; // Remove this line to use Angular Universal
export function getBaseUrl() {
	return environment.apiEndpoint + "/api/";
}
const MsSettings = "msSettings";

export function getConfig(): AuthenticationConfiguration {
	let json;
	if (localStorage.getItem(MsSettings) != null) {
		try {
			json = JSON.parse(localStorage.getItem(MsSettings));
		} catch (error) {
			console.error(error);
			const storedCacheVersion = localStorage.getItem('cache-version');
			localStorage.clear();
			localStorage.setItem('cache-version', storedCacheVersion ? storedCacheVersion : '');
			console.error("Cleared local storage. Reload the page.");
		}
	}
	else {
		let request = new XMLHttpRequest();
		request.open('GET', `${getBaseUrl() + "login/MsSettings"}`, false);  // request application settings synchronous

		// Set custom headers
		request.setRequestHeader('Pragma', 'no-cache');
		request.setRequestHeader('Strict-Transport-Security', 'max-age=31536000; includeSubDomains');
		request.setRequestHeader('X-Content-Type-Options', 'nosniff');
		request.setRequestHeader('Content-Security-Policy', "default-src 'self'; object-src 'none'; child-src 'self'; frame-ancestors 'none'; upgrade-insecure-requests; block-all-mixed-content");

		request.send(null);
		json = JSON.parse(request.responseText);
		localStorage.setItem(MsSettings, JSON.stringify(json))
	}

	let authConfig = new AuthenticationConfiguration();
	if (environment.environmentName == "DEVELOPMENT") {
		authConfig.redirectUri = "https://localhost:4200/login";
		authConfig.postLogoutRedirectUri = "https://localhost:4200/login?logout=1";
		if (json.msClientId) {
			authConfig.clientId = json.msClientId;
		}
		if (json.msGraphApi) {
			authConfig.GraphApi = json.msGraphApi;
		}
	}
	else {
		if (json.msLoginRedirectUrl) {
			authConfig.redirectUri = json.msLoginRedirectUrl;
		}
		if (!authConfig.redirectUri) {
			authConfig.redirectUri = getBaseUrl();
		}
		if (json.msLogoutRedirectUrl) {
			authConfig.postLogoutRedirectUri = json.msLogoutRedirectUrl;
		}
		if (!authConfig.postLogoutRedirectUri) {
			authConfig.postLogoutRedirectUri = getBaseUrl();
		}
		if (json.msClientId) {
			authConfig.clientId = json.msClientId;
		}
		if (json.msGraphApi) {
			authConfig.GraphApi = json.msGraphApi;
		}
		if (json.msInteractionType) {
			authConfig.InteractionType = json.msInteractionType;
		}
	}
	return authConfig;
}
// Creates custom client application to implement login
// functionality
export function loggerCallback(logLevel: LogLevel, message: string) {
}
// Creates custom client application to implement login
// functionality
export function MSALInstanceFactory(): IPublicClientApplication {
	const authConfig = getConfig();
	return new PublicClientApplication({
		auth: {
			clientId: authConfig.clientId,
			// authority: 'https://login.microsoftonline.com/<tenant-id',
			redirectUri: authConfig.redirectUri,
			postLogoutRedirectUri: authConfig.postLogoutRedirectUri,
			navigateToLoginRequestUrl: false,
		},
		cache: {
			cacheLocation: BrowserCacheLocation.LocalStorage,
			storeAuthStateInCookie: isIE, // set to true for IE 11
		},
		system: {
			loggerOptions: {
				loggerCallback,
				logLevel: LogLevel.Info,
				piiLoggingEnabled: false
			}
		}
	});
}
// provides authRequest configuration
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
	const authConfig = getConfig();
	const protectedResourceMap = new Map<string, Array<string>>();
	protectedResourceMap.set(authConfig.GraphApi, ['user.read']);
	return {
		// authConfig.InteractionType == "popup" ? InteractionType.Popup :
		interactionType: (InteractionType.Redirect),
		protectedResourceMap
	};
}
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
	return {
		// authConfig.InteractionType == "popup" ? InteractionType.Popup :
		interactionType: (InteractionType.Redirect),
		authRequest: {
			scopes: ['user.read']
		}
	};
}

@NgModule({
	declarations: [
		AppComponent
	],
	exports: [],
	bootstrap: [AppComponent, MsalRedirectComponent], imports: [CommonModule,
		BrowserModule,
		BrowserAnimationsModule,
		CommonPageLayoutModule,
		FormsModule,
		AppRoutingModule,
		InfoTableModule,
		NavbarModule,
		TaskPopupModule,
		DxPopupModule,
		DxButtonModule,
		DxTabsModule,
		DxScrollViewModule,
		DxDashboardControlModule,
		ConfirmationPopUpModule,
		ControlPopUpModule,
		SettingsRendererModule,
		SelectionOptionsRendererModule,
		MsalModule,
		InfiniteScrollModule], providers: [
			HttpClient,
			HttpClientModule,
			QRCodeModule,
			{ provide: DEFAULTS_TOKEN, useValue: DEFAULTS },
			{
				provide: LOCALE_ID,
				useFactory: localeIdFactory,
				deps: [LocaleService]
			},
			{
				provide: APP_INITIALIZER,
				useFactory: localeInitializer,
				deps: [LocaleService, LOCALE_ID],
				multi: true,
			},
			{ provide: AngularUrlSerializer, useClass: UrlSerializer },
			{ provide: AngularRouteReuseStrategy, useClass: RouteReuseStrategy },
			{
				provide: APP_INITIALIZER,
				useFactory: (routeConfigService: RouteConfigService) => () => routeConfigService.initializeRoutes(),
				deps: [RouteConfigService],
				multi: true,
			},
			{
				provide: APP_INITIALIZER,
				useFactory: (navbarService: NavbarService) => () => navbarService.loadNavbarItems(),
				deps: [NavbarService],
				multi: true,
			},
			// {
			// 	provide: HTTP_INTERCEPTORS,
			// 	useFactory: () => authInterceptor,
			// 	multi: true
			// },
			{
				provide: HTTP_INTERCEPTORS,
				useClass: AuthInterceptor,  // ← your class, not the functional one
				multi: true
			},
			{
				provide: APP_BASE_HREF,
				useFactory: (platformLocation: PlatformLocation) => platformLocation.getBaseHrefFromDOM(),
				deps: [PlatformLocation],
			},
			{
				provide: HTTP_INTERCEPTORS,
				useClass: MsalInterceptor,
				multi: true
			},
			{
				provide: MSAL_INSTANCE,
				useFactory: MSALInstanceFactory
			},
			{
				provide: MSAL_GUARD_CONFIG,
				useFactory: MSALGuardConfigFactory
			},
			{
				provide: MSAL_INTERCEPTOR_CONFIG,
				useFactory: MSALInterceptorConfigFactory
			},
			MsalService,
			MsalGuard,
			MsalBroadcastService,
			{ provide: ErrorHandler, useClass: GlobalErrorHandler },
			provideHttpClient(withInterceptorsFromDi()),
		]
})
export class AppModule {

	// For global-level configurations or initializations that affect the entire application.
	constructor(
		private _injector: Injector
	) {
		ServiceLocator.injector = this._injector;

		// dxNumberBox.defaultOptions<dxNumberBoxProperties>(
		// 	{
		// 		options: {
		// 			// showClearButton: true,
		// 			format: '#,##0.####',
		// 			valueChangeEvent: 'keyup',

		// 			onKeyUp: (evt: KeyUpEvent) => {
		// 				// evt.event.stopPropagation();
		// 				NumberBoxComponent.formatLoad(evt);
		// 			}
		// 		}
		// 	}
		// );

		DataGrid.defaultOptions<dxDataGridProperties>(
			{
				options: {
					showBorders: false,
					showColumnLines: true,
					showRowLines: false,
					rowAlternationEnabled: true,

					columnResizingMode: 'widget',
					columnMinWidth: 50,
					allowColumnReordering: false,
					allowColumnResizing: true,

					sorting: {
						mode: 'multiple'
					},
					selection: {
						mode: 'multiple'
					},
					scrolling: {
						mode: 'infinite',
						useNative: true,
					},
					loadPanel: {
						enabled: true,

						width: 250,
						height: 100,

						text: 'Loading...',

						showIndicator: true,
						indicatorSrc: 'https://js.devexpress.com/Content/data/loadingIcons/rolling.svg'
					},
					filterRow: {
						visible: true,
					},
					headerFilter: {
						visible: true,
					},
				},
			}
		);
	}
}


export class AuthenticationConfiguration {
	clientId!: string;
	authority!: string;
	redirectUri!: string;
	postLogoutRedirectUri!: string;
	GraphApi!: string;
	InteractionType!: string;
	scopes!: string[];
	constructor(init?: Partial<AuthenticationConfiguration>) {
		Object.assign(this, init);
	}
}
